import * as APIHelper from "services/api"
import * as endPoint from "shared/constants/endpoint"

class FileUploadHistoryBusiness {
  getData = async searchParams => {
    const options = { params: searchParams }
    const response = (await APIHelper.getRequest(`${endPoint.uploadHistory.list}`, options)) || {}
    return response || []
  }

  addData = async item => {
    const response = await APIHelper.postRequest(`${endPoint.uploadHistory.post}`, item)
    return response
  }
}

export const fileUploadHistoryBusiness = new FileUploadHistoryBusiness()
